import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { IconSearch } from '@tabler/icons-react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Link } from 'react-router-dom'

export default function SearchResult() {

    return (
        <>
            <Breadcrumb title="Search Result" path="Pages / Search Result" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='relative w-full overflow-hidden mb-30'>
                    <input type='text' id='searchMail' name='searchMail' placeholder='Search Mail' className='bg-bg-dark border border-border w-full py-[6px] pl-[12px] pr-60 min-h-[35px] rounded-[4px] placeholder:text-text-secondary focus:outline-none' />
                    <button aria-label="search icon" className="absolute top-[50%] translate-y-[-50%] border-l border-l-border right-[1px] py-[6px] px-[12px] min-h-[33px] bg-bg-light rounded-r-[3px]">
                        <IconSearch className="text-text-primary w-[20px] h-[20px] stroke-[1.5]" />
                    </button>
                </div>
                <Tabs className="custom-tab2">
                    <TabList>
                        <Tab>
                            Web
                        </Tab>
                        <Tab>
                            Images
                        </Tab>
                        <Tab>
                            Videos
                        </Tab>
                    </TabList>
                    <div className='my-20'>
                        <p>
                            Search Result For "Web Tab"
                        </p>
                        <strong>
                            About 16,853 result ( 0.13 seconds)
                        </strong>
                    </div>
                    <TabPanel>
                        <div className='pb-30 mb-30 border-b border-border last:border-none'>
                            <div>
                                <Link to="#" className='text-[16px]/[19.2px] font-medium text-blue transition-all duration-300 hover:text-blue-100'>
                                    sQuare - Bootstrap 4 Light & Dark Admin with Free Angular5 + UI Kit
                                </Link>
                            </div>
                            <small>https://themeforest.net</small>
                            <p className='mt-10'>
                                sQuare Admin is Material Design premium admin dashboard theme. It’s builded on popular Twitter Bootstrap4 framework. sQuare is fully based on HTML5 + CSS3 Standards. Is fully responsive and clean on every device and every browser.
                            </p>
                            <div className='flex items-center gap-30 mt-20'>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    AdminCC
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    Swift Admin
                                </Link>
                            </div>
                        </div>
                        <div className='pb-30 mb-30 border-b border-border last:border-none'>
                            <div>
                                <Link to="#" className='text-[16px]/[19.2px] font-medium text-blue transition-all duration-300 hover:text-blue-100'>
                                    InfiniO - Bootstrap 4 Admin Dashboard Template
                                </Link>
                            </div>
                            <small>https://themeforest.net</small>
                            <p className='mt-10'>
                                InfiniO is fully professional, responsive, modern, multi-purpose and featured Admin template which can be used to create various website, Admin templates, Admin dashboards, Backend Websites, CMS, CRM or one can aldo build Blog, Business website and time line as well as portfolio. InfiniO Admin makes the development process easy and fast for you and aims to help you implement your idea to real time.
                            </p>
                            <div className='flex items-center gap-30 mt-20'>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    Oakleaf Admin
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    sQuare
                                </Link>
                            </div>
                        </div>
                        <div className='pb-30 mb-30 border-b border-border last:border-none'>
                            <div>
                                <Link to="#" className='text-[16px]/[19.2px] font-medium text-blue transition-all duration-300 hover:text-blue-100'>
                                    Compass - The ultimate Bootstrap 4 Admin Dashboard
                                </Link>
                            </div>
                            <small>https://themeforest.net</small>
                            <p className='mt-10'>
                                Compass Admin is Material Design premium admin dashboard theme. It’s builded on popular Twitter Bootstrap4 framework. Compass is fully based on HTML5 + CSS3 Standards. Is fully responsive and clean on every device and every browser.
                            </p>
                            <div className='flex items-center gap-30 mt-20'>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    AdminCC
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    Oakleaf Admin
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    sQuare
                                </Link>
                            </div>
                        </div>
                        <div className='pb-30 mb-30 border-b border-border last:border-none'>
                            <div>
                                <Link to="#" className='text-[16px]/[19.2px] font-medium text-blue transition-all duration-300 hover:text-blue-100'>
                                    Alpino - Bootstrap 4 Admin Dashboard Template
                                </Link>
                            </div>
                            <small>https://themeforest.net</small>
                            <p className='mt-10'>
                                15+ Dashboard, 100+ Integrated Plugins, 400+ Pages, Light and Dark Menu, The Multistep Form, Timeline view, Summermnote Editor, Image Cropping Tool, Easy to access Menu Styles
                            </p>
                            <div className='flex items-center gap-30 mt-20'>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    Oakleaf Admin
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    sQuare
                                </Link>
                                <Link to="#" className='text-blue transition-all duration-300 hover:text-blue-100'>
                                    AdminCC
                                </Link>
                            </div>
                        </div>
                        <div className='btn-group'>
                            <button className='btn btn-outline-blue'>
                                Previous
                            </button>
                            <button className='btn btn-blue'>
                                1
                            </button>
                            <button className='btn btn-outline-blue'>
                                2
                            </button>
                            <button className='btn btn-outline-blue'>
                                3
                            </button>
                            <button className='btn btn-outline-blue'>
                                Next
                            </button>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney's organic lomo retro fanny pack lo-fi farm-to-table readymade. Messenger bag gentrify pitchfork tattooed craft beer, iphone skateboard locavore carles etsy salvia banksy hoodie helvetica. DIY synth PBR banksy irony. Leggings gentrify squid 8-bit cred pitchfork. Williamsburg banh mi whatever gluten-free, carles pitchfork biodiesel fixie.
                    </TabPanel>
                    <TabPanel>
                        Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar helvetica VHS.
                    </TabPanel>
                </Tabs>
            </div>
        </>
    )
}
